import React from 'react';
import { Shield } from 'lucide-react';
import {
  isPrivatePlaceholder,
  privateArchiveBadgeLabel,
  privateArchiveHint,
} from '../../utils/archivePrivacyCopy';

export function PrivateArchiveBadge({ person, className = '' }) {
  if (!isPrivatePlaceholder(person)) return null;
  const name = person?.given_names || person?.full_name;
  return (
    <div
      className={`rounded-lg border border-[hsl(38_14%_86%)]/60 bg-[hsl(42_28%_99%)]/70 px-3 py-2.5 text-left ${className}`}
      data-testid="private-archive-badge"
    >
      <p className="flex items-center gap-1.5 text-[11px] font-medium uppercase tracking-[0.12em] text-muted-foreground">
        <Shield className="h-3 w-3 text-[hsl(var(--studio-accent,38_36%_42%))]" aria-hidden />
        {privateArchiveBadgeLabel()}
      </p>
      <p className="mt-1 text-xs leading-relaxed text-muted-foreground/90">{privateArchiveHint(name)}</p>
    </div>
  );
}

export default PrivateArchiveBadge;
